export default __webpack_public_path__ + "static/custom-logo-4-5d5f62bc1cd160115eed14c908ebe35c.webp";